import React, { useEffect } from 'react'

import i18n from 'i18n'
import { getMaintenanceNow } from 'services/maintenance'

import MaintenanceFrame from './MaintenanceFrame'
import styles from './style.module.scss'

// setTimeout 32비트 한계(약 24.8일). 점검은 통상 단기지만 방어적으로 cap.
const MAX_TIMEOUT_MS = 2 ** 31 - 1

interface BlackoutPageProps {
  url: string
  /** blackout_period.end (ISO8601). 도래 시 자동 새로고침으로 복귀. */
  end: string
  lang?: string
}

/** 점검 차단 풀페이지(작업/긴급 공용). 닫기 불가, 종료 시각에 자동 복귀. */
function BlackoutPage({ url, end, lang }: BlackoutPageProps): React.ReactElement {
  useEffect(() => {
    const endMs = Date.parse(end)
    if (Number.isNaN(endMs)) return undefined

    const delay = endMs - getMaintenanceNow().getTime()
    if (delay <= 0) {
      window.location.reload()
      return undefined
    }

    const timer = setTimeout(() => window.location.reload(), Math.min(delay, MAX_TIMEOUT_MS))
    return () => clearTimeout(timer)
  }, [end])

  return (
    <div className={styles.fullscreen} data-testid="maintenance-blackout">
      <MaintenanceFrame url={url} title={i18n.t('maintenance.blackoutTitle')} lang={lang} />
    </div>
  )
}

export default BlackoutPage
